import React from 'react';

const PrevIcon = ({ disabled }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" fillOpacity={disabled}>
    <path d="M15.8333 10.0001H4.16666M4.16666 10.0001L9.99999 15.8334M4.16666 10.0001L9.99999 4.16675" stroke="#344054" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default PrevIcon;
